export const SYNC_SUB_DEVICES = '@@subDevices/syncSubDevices'

export const UPDATE_SUB_DEVICES = '@@scenesList/updateSubDevices'
